/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/

import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { SidebarToggleBtn } from '../sidebar/SidebarToggleBtn';
import { SearchBtn } from './SearchBtn';
import { Link } from '@backstage/core-components';
import LogoFull from '../logo/LogoFull';
import { AccountMenu } from './AccountMenu';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { getPortalTitle } from '../../../utils/configUtility';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  content: {
    flexGrow: 1,
    marginLeft: theme.spacing(2),
  },
  appName: {
    borderLeft: `1px rgba(255, 255, 255, 0.6) solid`,
    padding: `0px ${theme.spacing(2)}px`,
    fontWeight: 500,
  },
  logoLink: {
    lineHeight: 0,
  },
}));

export const AppHeader = () => {
  const classes = useStyles();
  const portalName = getPortalTitle(useApi(configApiRef));
  return (
    <div className={classes.root}>
      <AppBar position="fixed">
        <Toolbar>
          <SidebarToggleBtn />
          <Link
            to="/"
            underline="none"
            aria-label="Home"
            className={classes.logoLink}
          >
            <LogoFull />
          </Link>
          <div className={classes.content}>
            <Typography variant="h6" className={classes.appName}>
              {portalName}
            </Typography>
          </div>
          <SearchBtn />
          {/* <NotificationsBtn webNotificationsEnabled /> */}
          <AccountMenu />
        </Toolbar>
      </AppBar>
    </div>
  );
};
